import { useState } from "react";
import {
  Collapse,
  CollapseToggle,
  CustomCard,
  Card,
  ICONS,
} from "taltech-styleguide";

export const AuditingBox = () => {
  const [collapse1Open, setCollapse1Open] = useState(false);
  const [collapse2Open, setCollapse2Open] = useState(false);
  const [collapse3Open, setCollapse3Open] = useState(false);
  const [collapse4Open, setCollapse4Open] = useState(false);

  return (
    <>
      <CollapseToggle
        id="toggle-1"
        icon={ICONS.GIFT}
        isExpanded={collapse1Open}
        onClick={() => setCollapse1Open(!collapse1Open)}
        aria-controls="collapse-1"
      >
        Color toggle
      </CollapseToggle>
      <Collapse in={collapse1Open} aria-labelledby="toggle-1">
        <div id="collapse-1">
          <Card className="no-limit">
            <Card.Body>
              Anim pariatur cliche reprehenderit, enim eiusmod high life
              accusamus terry richardson ad squid. Nihil anim keffiyeh
              helvetica, craft beer labore wes anderson cred nesciunt sapiente
              ea proident.
            </Card.Body>
          </Card>
        </div>
      </Collapse>
      <CollapseToggle
        id="toggle-2"
        className="mt-2"
        variant="light"
        isExpanded={collapse2Open}
        onClick={() => setCollapse2Open(!collapse2Open)}
      >
        Light toggle
      </CollapseToggle>
      <Collapse in={collapse2Open} aria-labelledby="toggle-2">
        <div id="collapse-2">
          <Card className="no-limit">
            <Card.Body>
              Anim pariatur cliche reprehenderit, enim eiusmod high life
              accusamus terry richardson ad squid. Nihil anim keffiyeh
              helvetica, craft beer labore wes anderson cred nesciunt sapiente
              ea proident.
            </Card.Body>
          </Card>
        </div>
      </Collapse>
      <CollapseToggle
        id="toggle-3"
        className="mt-2"
        variant="static-light"
        isExpanded={collapse3Open}
        onClick={() => setCollapse3Open(!collapse3Open)}
      >
        Static light toggle
      </CollapseToggle>
      <Collapse in={collapse3Open} aria-labelledby="toggle-3">
        <div id="collapse-3">
          <Card className="no-limit">
            <Card.Body>
              Anim pariatur cliche reprehenderit, enim eiusmod high life
              accusamus terry richardson ad squid. Nihil anim keffiyeh
              helvetica, craft beer labore wes anderson cred nesciunt sapiente
              ea proident.
            </Card.Body>
          </Card>
        </div>
      </Collapse>
      <CollapseToggle
        id="toggle-4"
        className="mt-2"
        variant="transparent"
        isExpanded={collapse4Open}
        onClick={() => setCollapse4Open(!collapse4Open)}
      >
        Transparent toggle
      </CollapseToggle>
      <Collapse in={collapse4Open} aria-labelledby="toggle-4">
        <div id="collapse-4">
          <CustomCard padding="lg" className="no-limit card--no-shadow">
            <Card.Body>
              Anim pariatur cliche reprehenderit, enim eiusmod high life
              accusamus terry richardson ad squid. Nihil anim keffiyeh
              helvetica, craft beer labore wes anderson cred nesciunt sapiente
              ea proident.
            </Card.Body>
          </CustomCard>
        </div>
      </Collapse>
    </>
  );
};
